import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { userAccountTypes } from '../types/user';
import { TranslatedCopy } from '../intl/TranslatedCopy';
import { Button } from '../components';
import { DownloadModalTransactionReports, DownloadModalCancelOverlay } from '../downloads';
import { setStatus, generateReport } from '../downloads/actions';
import { selections } from '../downloads/reducer';
import { closeModal, openModal, disableModal, enableModal } from '../components/modal/actions';
import { getUserAccount, selectDepartments, billableDepartments } from '../user/selectors';
import { STATUS_IDLE, REPORT_TYPE_TRANSACTIONS, CONTRACT_PERIOD_CURRENT } from '../downloads/constants';
import { PAYMENT_BILLABLE } from '../shop/constants';
import { mapDepartmentName } from '../orders/status/util';
import { getIsGreaterChinaSalesOrg } from '../gamedayAccount/selectors';
import {
  GA_EVENT_PAGE_VIEW,
  GA_EVENT_TRANSACTION_REPORT_DOWNLOAD_CLICK,
  GA_EVENT_TRANSACTION_REPORTS_PAGE_VIEW,
  sendEventToGA
} from '../analytics/constants';

export class TransactionReports extends Component {
  handleConfirmClick = () => {
    const {
      closeModal,
      disableModal,
      enableModal,
      selections,
      generateReport,
      account: { name: accountName, number: accountNumber },
      departments,
      billableDepartments
    } = this.props;

    const allDept = !(
      selections &&
      selections.transactionReport_department &&
      selections.transactionReport_department !== 'ALL'
    );

    const { departmentName } = allDept
      ? { departmentName: null }
      : mapDepartmentName(
          [{ departmentNumber: selections.transactionReport_department }],
          [...billableDepartments, ...departments],
          billableDepartments.length > 0 ? [accountNumber, billableDepartments[0].customerNumber] : [accountNumber]
        )[0];

    generateReport({
      type: REPORT_TYPE_TRANSACTIONS,
      data: {
        title: 'downloads.type.report.transactions',
        // --
        accountId: accountNumber,
        accountName: accountName,
        compType: 'EQUIP', // Hardcoded until clarity received
        period:
          selections && selections.transactionReport_period
            ? selections.transactionReport_period
            : CONTRACT_PERIOD_CURRENT,
        billable:
          selections && selections.transactionReport_type
            ? selections.transactionReport_type === PAYMENT_BILLABLE
            : false,

        // Both supplied null if ALL depts
        // Both required if fetching for single dept
        departmentId: allDept ? null : selections.transactionReport_department,
        departmentName: departmentName
      }
    }).then(() => enableModal());

    closeModal();
    disableModal();

    sendEventToGA(GA_EVENT_TRANSACTION_REPORT_DOWNLOAD_CLICK);
  };

  cancelDownload = () => {
    const { setStatus, enableModal } = this.props;
    setStatus(STATUS_IDLE);
    enableModal();
  };

  handleTransactionReportsClick = () => {
    const { openModal, closeModal } = this.props;
    openModal({
      type: 'alert',
      title: <TranslatedCopy id='transactions.history.title' />,
      content: <DownloadModalTransactionReports />,
      confirmText: <TranslatedCopy id='global.download' />,
      confirmAction: this.handleConfirmClick,
      cancelText: <TranslatedCopy id='global.button.cancel' />,
      cancelAction: closeModal,
      disabledContent: <DownloadModalCancelOverlay cancelDownload={this.cancelDownload} />
    });

    sendEventToGA(GA_EVENT_PAGE_VIEW, { pageViewType: GA_EVENT_TRANSACTION_REPORTS_PAGE_VIEW });
  };

  render() {
    const { isMobile, isGreaterChinaSalesOrg } = this.props;
    const buttonClasses = isMobile
      ? 'bg-secondary-grey border-bottom-medium-grey d-sm-b prl5-sm pt4-sm pb4-sm u-full-width ta-sm-l'
      : 'p0-sm mb1-sm body-3 u-bold text-color-secondary';

    const renderButton = () => (
      <>
        {!isGreaterChinaSalesOrg && (
          <div className='d-sm-h d-md-b mb-1-md'>
            <Button
              data-e2e='transaction-reports'
              className={buttonClasses}
              textLink
              onClick={this.handleTransactionReportsClick}
            >
              <TranslatedCopy id='transactions.history.link' />
            </Button>
          </div>
        )}
      </>
    );

    return isMobile ? <li className='body-4 text-color-secondary'>{renderButton()}</li> : renderButton();
  }
}

TransactionReports.propTypes = {
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  disableModal: PropTypes.func.isRequired,
  enableModal: PropTypes.func.isRequired,
  setStatus: PropTypes.func.isRequired,
  generateReport: PropTypes.func.isRequired,
  isGreaterChinaSalesOrg: PropTypes.bool,
  isMobile: PropTypes.bool,
  selections: PropTypes.object,
  account: userAccountTypes,
  departments: PropTypes.array,
  billableDepartments: PropTypes.array
};

TransactionReports.defaultProps = {
  isMobile: false,
  selections: null,
  account: null,
  departments: null,
  billableDepartments: null,
  isGreaterChinaSalesOrg: null
};

const mapStateToProps = state => ({
  selections: selections(state),
  account: getUserAccount(state),
  departments: selectDepartments(state),
  billableDepartments: billableDepartments(state),
  isGreaterChinaSalesOrg: getIsGreaterChinaSalesOrg(state)
});

const connector = connect(mapStateToProps, {
  openModal,
  closeModal,
  disableModal,
  enableModal,
  setStatus,
  generateReport
});

export default connector(TransactionReports);
